import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/link-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M4.92969 10.5855C5.32022 10.1953 5.95333 10.1951 6.34375 10.5855C6.73418 10.9759 6.73398 11.609 6.34375 11.9995L4.92969 13.4146C3.36763 14.9767 3.36761 17.5088 4.92969 19.0708C6.49178 20.6329 9.02385 20.6329 10.5859 19.0708L12 17.6568C12.3905 17.2662 13.0245 17.2662 13.415 17.6568C13.8053 18.0472 13.8052 18.6803 13.415 19.0708L12 20.4849C9.65687 22.828 5.85877 22.828 3.51563 20.4849C1.17248 18.1418 1.17248 14.3427 3.51563 11.9995L4.92969 10.5855ZM14.793 7.79252C15.1835 7.40199 15.8175 7.40199 16.208 7.79252C16.5985 8.18304 16.5985 8.81705 16.208 9.20755L9.20801 16.2076C8.8175 16.5981 8.1835 16.598 7.79297 16.2076C7.40245 15.817 7.40246 15.183 7.79297 14.7925L14.793 7.79252ZM12 3.51517C14.3432 1.17203 18.1422 1.17203 20.4854 3.51517C22.8285 5.85831 22.8285 9.65641 20.4854 11.9995L19.0713 13.4146L18.9951 13.4829C18.6024 13.803 18.0233 13.7805 17.6572 13.4146C17.2667 13.0241 17.2667 12.3901 17.6572 11.9995L19.0713 10.5855C20.6333 9.0234 20.6333 6.49132 19.0713 4.92923C17.5092 3.36715 14.9771 3.36717 13.415 4.92923L12 6.3433C11.6095 6.73352 10.9764 6.73372 10.5859 6.3433C10.1956 5.95287 10.1957 5.31976 10.5859 4.92923L12 3.51517Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Link01Icon };
